import _ from 'lodash';

export function mergeUniqueRules(rules = [], changed = []) {
  const merged = changed.map((o) => ({ ...o }));

  for (const r of rules) {
    const target = merged.find((o) => Object.keys(o).some((k) => Object.keys(r).includes(k)));
    if (target) {
      for (const [k, v] of Object.entries(r)) {
        if (!(k in target)) target[k] = v;
      }
    } else merged.push({ ...r });
  }

  return merged.filter((o) => !_.isEmpty(o));
}
